import "@tento-ui/components/rich-text-editor/rich-text-editor";
import "@tento-ui/brand/blog/blog-minimal-post-pagelet";

import { RichTextEditor } from "@tento-ui/components/rich-text-editor/rich-text-editor";
import { BlogMinimalPostPagelet } from "@tento-ui/brand/blog/blog-minimal-post-pagelet";
import { GESTURE_MANAGER } from "@tento-ui/gesture-manager";
import type { BlogPost } from "../blog-data";
import type { BlogPostPage, BlogPostRoute } from "../blog-variant";

export const minimalPostRoute: BlogPostRoute = {
  make(post: BlogPost, delegate: BlogPostPage.Delegate): HTMLElement {
    const $content = RichTextEditor.make() as RichTextEditor;
    $content.bind({ markdown: post.content ?? "", editable: false });

    const $back = document.createElement("a");
    $back.textContent = "\u2190 Home";
    $back.assignStyles({
      color: "var(--text-sec)",
      textDecoration: "none",
      cursor: "pointer",
    });
    $back.style.setProperty("--font-size", "var(--text-12px)");

    GESTURE_MANAGER.addPointerEvent($back, {
      onClick: () => delegate.onBack(),
    });

    return BlogMinimalPostPagelet.makeWith({ content: $content, back: $back });
  },
  bind(pagelet: HTMLElement, _post: BlogPost, _delegate: BlogPostPage.Delegate): HTMLElement {
    return pagelet;
  },
};
